// extracted by mini-css-extract-plugin
export var active_item = "content-table-module--active_item--wh9FV";
export var tableContainer = "content-table-module--table-container--qwbx9";